import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { TypeDeSorts } from 'src/app/_enums/typeDeSort';
import { CommandResult } from 'src/app/_models/commandResult';
import { Competence } from 'src/app/_models/competence';
import { Joueur } from 'src/app/_models/joueur';
import { Sort } from 'src/app/_models/sort';
import { CreatePersonnageCommand } from 'src/app/_models/_commands/createPersonnageCommand';
import { CompetenceService } from 'src/app/_services/competence.service';
import { SortService } from 'src/app/_services/sort.service';
import { Astre, Astres } from '../../_enums/astre';
import { Legion, Legions } from '../../_enums/legion';
import { Personnage } from '../../_models/personnage';
import { CharacterSheetService } from '../../_services/character-sheet.service';

@Component({
  selector: 'app-character-sheet-background',
  templateUrl: './background.component.html',
  styleUrls: ['./background.component.scss']
})
export class CharacterSheetBackgroundComponent implements OnInit {
  isRead: boolean = true;
  @Input()  personnage!: Personnage;
  @Output() personnageChange = new EventEmitter<Personnage>();
  backgroundForm!: FormGroup;
  submitted: boolean = false;
  constructor(private formBuilder: FormBuilder, private characterSheetService: CharacterSheetService, private sortService: SortService, private competenceService: CompetenceService, private route: ActivatedRoute, private router: Router) {
   }

  ngOnInit(): void {
    this.initializeForm();
  }
  
  initializeForm() {
    this.backgroundForm = this.formBuilder.group({
      personnalite: [this.personnage.background?.personnalite],
      concept: [this.personnage.background?.concept],
      historique: [this.personnage.background?.historique],
      butCourtTerme: [this.personnage.background?.butCourtTerme],
      butMoyenTerme: [this.personnage.background?.butMoyenTerme],
      butLongTerme: [this.personnage.background?.butLongTerme],
    });
  }

  onSubmit() {
    this.submitted = true;
    const command = this.backgroundForm.value;
    command.personnageId = this.personnage.id;
    this.characterSheetService.updateBackground(command)
    .pipe(first())
    .subscribe({
      next: (result: CommandResult) =>
      {
        this.personnage = result.result as Personnage;
        this.personnageChange.emit(this.personnage);
        this.submitted = false;
        this.switchMode();
      }
    }); 
  }

  switchMode() {
    this.isRead = !this.isRead;
  }
  
}